var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAndmuchmuchmore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65,
    height: 65,
    viewBox: "0 0 98 98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#BE0A75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F4A95"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7140",
    x: 46.667,
    y: 44,
    width: 44.667,
    height: 32.667,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.082
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7141",
    x: 41.068,
    y: 46.667,
    width: 56.932,
    height: 51.333,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.082
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7142",
    x: 34.667,
    y: 0,
    width: 63.333,
    height: 62,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.082
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7143",
    x: 42.667,
    y: 5.333,
    width: 20.667,
    height: 28.667,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.082
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7144",
    x: 48,
    y: 5.333,
    width: 20.667,
    height: 28.667,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.082
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7145",
    x: 53.333,
    y: 5.333,
    width: 20.667,
    height: 28.667,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.082
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7146",
    x: 58.667,
    y: 5.333,
    width: 20.667,
    height: 28.667,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.082
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7147",
    x: 64,
    y: 5.333,
    width: 20.667,
    height: 28.667,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.082
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7148",
    x: 69.333,
    y: 5.333,
    width: 20.667,
    height: 28.667,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.082
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7149",
    x: 46.667,
    y: 62.667,
    width: 26,
    height: 20.667,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.082
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7150",
    x: 57.333,
    y: 62.667,
    width: 34,
    height: 20.667,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-11"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.082
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7151",
    x: 17.333,
    y: 14.667,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-12"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.082
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7152",
    x: 17.593,
    y: 34.667,
    width: 44.407,
    height: 63.333,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-13"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.082
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-13"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7153",
    x: 3.017,
    y: 7.65,
    width: 30,
    height: 30,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-14"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.082
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-14"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7154",
    x: 0,
    y: 48,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-15"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.082
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-15"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "And_much_much_more",
    "data-name": "And much, much more",
    transform: "translate(-7 -10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1239",
    "data-name": "Group 1239",
    transform: "translate(16 16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_7140)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7140-2",
    "data-name": "Path 7140",
    d: "M296,292v2.667h25.333a1.333,1.333,0,0,0,1.333-1.333v-12A1.333,1.333,0,0,0,321.333,280H296v2.667h24V292Z",
    transform: "translate(-240.33 -230)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_7141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7141-2",
    "data-name": "Path 7141",
    d: "M298.673,318.667H268.007v2.667h30.667a5.339,5.339,0,0,1-5.333,5.333H264.007a5.378,5.378,0,0,1-1.068-.107l-.531,2.613a8.052,8.052,0,0,0,1.6.16H293.34a8.009,8.009,0,0,0,8-8V296h-2.667Z",
    transform: "translate(-212.34 -243.33)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_7142)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7142-2",
    "data-name": "Path 7142",
    d: "M263,41.333h-.333v-4h1a3,3,0,0,0,3-3V20.667A4.672,4.672,0,0,0,262,16H237.333v2.667H262a2,2,0,0,1,2,2V34.333a.334.334,0,0,1-.333.333h-34a.334.334,0,0,1-.333-.333V20.667a2,2,0,0,1,2-2h3.333V16h-3.333a4.672,4.672,0,0,0-4.667,4.667V34.333a3,3,0,0,0,3,3h1v4h-.333A6.341,6.341,0,0,0,224,47.667V48h2.667v-.333A3.671,3.671,0,0,1,230.333,44H263a3.671,3.671,0,0,1,3.667,3.667v5.667H233.333V56h33.333v4h2.667V47.667A6.341,6.341,0,0,0,263,41.333Zm-29.667,0v-4H260v4Z",
    transform: "translate(-180.33 -10)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_7143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7143-2",
    "data-name": "Path 7143",
    d: "M272,48h2.667V58.667H272Z",
    transform: "translate(-220.33 -36.67)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_7144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7144-2",
    "data-name": "Path 7144",
    d: "M304,48h2.667V58.667H304Z",
    transform: "translate(-247 -36.67)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_7145)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7145-2",
    "data-name": "Path 7145",
    d: "M336,48h2.667V58.667H336Z",
    transform: "translate(-273.67 -36.67)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_7146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7146-2",
    "data-name": "Path 7146",
    d: "M368,48h2.667V58.667H368Z",
    transform: "translate(-300.33 -36.67)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_7147)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7147-2",
    "data-name": "Path 7147",
    d: "M400,48h2.667V58.667H400Z",
    transform: "translate(-327 -36.67)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_7148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7148-2",
    "data-name": "Path 7148",
    d: "M432,48h2.667V58.667H432Z",
    transform: "translate(-353.67 -36.67)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_7149)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7149-2",
    "data-name": "Path 7149",
    d: "M296,392h8v2.667h-8Z",
    transform: "translate(-240.33 -323.33)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_7150)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7150-2",
    "data-name": "Path 7150",
    d: "M360,392h16v2.667H360Z",
    transform: "translate(-293.67 -323.33)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_7151)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7151-2",
    "data-name": "Path 7151",
    d: "M120.693,113.169l3.967,2.17,2.17,3.967a1.333,1.333,0,0,0,2.34,0l2.17-3.967,3.967-2.17a1.333,1.333,0,0,0,0-2.34l-3.967-2.17-2.17-3.967a1.333,1.333,0,0,0-2.34,0l-2.17,3.967-3.967,2.17a1.333,1.333,0,0,0,0,2.34Zm5.589-2.357a1.334,1.334,0,0,0,.53-.53L128,108.112l1.187,2.171a1.334,1.334,0,0,0,.53.53L131.888,112l-2.171,1.187a1.334,1.334,0,0,0-.53.53L128,115.888l-1.187-2.171a1.334,1.334,0,0,0-.53-.53L124.112,112Z",
    transform: "translate(-93.67 -83.33)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_7152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7152-2",
    "data-name": "Path 7152",
    d: "M147.967,237a13.015,13.015,0,0,0-13-13H134.3a13.035,13.035,0,0,0-12.74,10.4l2.613.53a10.36,10.36,0,0,1,10.127-8.265h.667A10.345,10.345,0,0,1,145.3,237v7h-8v2.667h8v2.667h-6.667V252H145.3v4.333a10.345,10.345,0,0,1-10.333,10.333H134.3a10.324,10.324,0,0,1-3.248-.52l-.837,2.532a12.987,12.987,0,0,0,4.085.655h.667a13.015,13.015,0,0,0,13-13Z",
    transform: "translate(-94.97 -183.33)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_7153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7153-2",
    "data-name": "Path 7153",
    d: "M34.794,69.069l2.674,1.462,1.462,2.674a1.333,1.333,0,0,0,2.34,0l1.462-2.674,2.674-1.462a1.333,1.333,0,0,0,0-2.34l-2.674-1.462-1.462-2.674a1.333,1.333,0,0,0-2.34,0l-1.462,2.674-2.674,1.462a1.333,1.333,0,0,0,0,2.34Zm4.3-1.65a1.334,1.334,0,0,0,.53-.53l.48-.878.48.878a1.334,1.334,0,0,0,.53.53l.878.48-.878.48a1.334,1.334,0,0,0-.53.53l-.48.878-.48-.878a1.334,1.334,0,0,0-.53-.53l-.878-.48Z",
    transform: "translate(-22.08 -48.25)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_7154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7154-2",
    "data-name": "Path 7154",
    d: "M48,320a16,16,0,1,0-16,16A16,16,0,0,0,48,320Zm-2.667,0a13.252,13.252,0,0,1-1.512,6.164L25.836,308.179A13.33,13.33,0,0,1,45.333,320Zm-4.9,10.32L28.943,318.828l-1.886,1.886,11.107,11.107a13.33,13.33,0,0,1-17.985-17.985l4.44,4.44,1.886-1.886-4.825-4.825a13.453,13.453,0,0,1,1.886-1.886L42.32,328.434a13.452,13.452,0,0,1-1.886,1.886Z",
    transform: "translate(-7 -250)",
    fill: "url(#linear-gradient)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndmuchmuchmore);
export default __webpack_public_path__ + "static/media/And much, much more.120c25f2d85a310e6a4a42d95efcef13.svg";
export { ForwardRef as ReactComponent };